import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { LinkContainer } from 'react-router-bootstrap';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { logout } from '../actions/userActions';
import { WEBSITE_LANGUAGE_OPTIONS, normalizeLanguageKey } from '../constants/languageNames';

function Header() {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    
    const userLogin = useSelector(state => state.userLogin);
    const { userInfo } = userLogin;

    const currentLangCode = normalizeLanguageKey(i18n.resolvedLanguage || i18n.language || 'en');
    const currentLang = WEBSITE_LANGUAGE_OPTIONS.find(l => l.code === currentLangCode) || WEBSITE_LANGUAGE_OPTIONS[0];

    function logoutHandler() {
        dispatch(logout());
    }

    return (
        <Navbar expand="md" className="site-navbar">
            <Container fluid className="px-4">
                <LinkContainer to="/">
                    <Navbar.Brand className="site-brand">
                        <img
                            src="/android-chrome-192x192.png"
                            className="site-brand-logo"
                            alt=""
                            width="48"
                            height="48"
                        />
                        <span className="site-brand-name">{t('brand')}</span>
                    </Navbar.Brand>
                </LinkContainer>

                <Navbar.Toggle aria-controls="navbarScroll" />
                <Navbar.Collapse id="navbarScroll">
                    <Nav
                        className="me-auto my-2 my-md-0 ms-md-3 d-flex flex-column flex-md-row"
                        style={{ gap: '0.25rem' }}
                        navbarScroll
                    >
                        <LinkContainer to="/about">
                            <Nav.Link><i className='fas fa-heart me-2'></i>{t('nav.aboutUs')}</Nav.Link>
                        </LinkContainer>
                        
                        <LinkContainer to="/">
                            <Nav.Link><i className='fas fa-book-open me-2'></i>{t('nav.createBook')}</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/genai/book-guide">
                            <Nav.Link><i className='fas fa-layer-group me-2'></i>{t('nav.bookLayoutGuide')}</Nav.Link>
                        </LinkContainer>
                        
                        <LinkContainer to="/faq">
                            <Nav.Link><i className='fas fa-question-circle me-2'></i>{t('nav.faq')}</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/contact">
                            <Nav.Link><i className='fas fa-envelope me-2'></i>{t('nav.contact')}</Nav.Link>
                        </LinkContainer>

                        <LinkContainer to="/cart">
                            <Nav.Link><i className='fas fa-shopping-cart me-2'></i>{t('nav.cart')}</Nav.Link>
                        </LinkContainer>

                        {userInfo ? (
                            <NavDropdown title={userInfo.name} id='username'>
                                <LinkContainer to='/profile'>
                                    <NavDropdown.Item>{t('nav.profile')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/orders'>
                                    <NavDropdown.Item>{t('nav.myOrders')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/genai/jobs'>
                                    <NavDropdown.Item>{t('nav.myBooks')}</NavDropdown.Item>
                                </LinkContainer>
                                <NavDropdown.Item onClick={logoutHandler}>
                                    {t('nav.logout')}
                                </NavDropdown.Item>
                            </NavDropdown>
                        ) : (
                            <LinkContainer to="/login">
                                <Nav.Link><i className='fas fa-user me-2'></i>{t('nav.login')}</Nav.Link>
                            </LinkContainer>
                        )}

                        {userInfo && userInfo.isAdmin && (
                            <NavDropdown title={t('nav.admin')} id='adminmenu'>
                                <LinkContainer to='/admin/dashboard'>
                                    <NavDropdown.Item>{t('nav.dashboard')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/admin/products'>
                                    <NavDropdown.Item>{t('nav.products')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/admin/orders'>
                                    <NavDropdown.Item>{t('nav.orders')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/admin/users'>
                                    <NavDropdown.Item>{t('nav.users')}</NavDropdown.Item>
                                </LinkContainer>
                                <LinkContainer to='/admin/genai/jobs'>
                                    <NavDropdown.Item>{t('nav.aiBookJobs')}</NavDropdown.Item>
                                </LinkContainer>
                                <NavDropdown.Item href='/admin/base/voucher/' target='_blank'>
                                    {t('nav.vouchers')}
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}
                    </Nav>

                    <NavDropdown
                        title={`${currentLang.flag} ${currentLang.label}`}
                        id="language-switcher"
                        className="me-3"
                    >
                        {WEBSITE_LANGUAGE_OPTIONS.map(lang => (
                            <NavDropdown.Item
                                key={lang.code}
                                active={lang.code === currentLangCode}
                                onClick={() => i18n.changeLanguage(lang.code)}
                            >
                                {lang.flag} {lang.label}
                            </NavDropdown.Item>
                        ))}
                    </NavDropdown>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default Header;
